export const GET_CLASS_RESTRICTION_SUCCESS = 'GET_CLASS_RESTRICTION_SUCCESS';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
